module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "Modal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "myModalLabel3",
      "aria-hidden": "true"
    },
    on: {
      "click": _vm.toggleModalFlagSon
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "modal-pd-pic",
    style: ({
      backgroundImage: 'url(' + _vm.setImageUrlModal(_vm.votePageShowPd.image) + ')'
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "pd-info"
  }, [_c('p', {
    staticClass: "pd-info-brand-name"
  }, [_vm._v(_vm._s(_vm.votePageShowPd.brand))]), _vm._v(" "), _c('h2', {
    staticClass: "pd-info-pd-name"
  }, [_vm._v(_vm._s(_vm.votePageShowPd.product))]), _vm._v(" "), _c('span', {
    staticClass: "pd-info-price"
  }, [_vm._v(_vm._s(_vm.votePageShowPd.price))]), _vm._v(" "), (_vm.votePageShowPd.capacity != '') ? _c('span', {
    staticClass: "pd-info-capacity"
  }, [_vm._v(" / " + _vm._s(_vm.votePageShowPd.capacity))]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "pd-info-detail"
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.votePageShowPd.detail) + "\n\t\t\t\t\t")]), _vm._v(" "), (_vm.checkPage(_vm.sendPage)) ? _c('div', {
    staticClass: "expert-comment-box"
  }, [_c('div', {
    staticClass: "modal-expert-pic-box"
  }, [_c('div', {
    staticClass: "pic",
    style: ({
      backgroundImage: 'url(' + _vm.setImageUrlModal(_vm.showExpert.photo) + ')'
    })
  }), _vm._v(" "), _c('span', {
    staticClass: "expert-name"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.showExpert.expert) + "\n\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-expert-comment"
  }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.showExpert.comment) + "\n\t\t\t\t\t\t")])]) : _c('div', {
    staticClass: "check-vote"
  }, [(_vm.sendPage == 'vote') ? _c('a', {
    staticClass: "vote-btn",
    on: {
      "click": function($event) {
        _vm.sendVote()
      }
    }
  }, [_vm._v("投它一票")]) : _c('a', {
    staticClass: "man"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-close-botton",
    attrs: {
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_vm._v("\n\t\t\t\t關閉視窗\n\t\t\t")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-691965da","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modal.vue
// module id = 152
// module chunks = 0